// extracted by mini-css-extract-plugin
export default {"container":"NZEWRWsG","text":"rdNxVWy4"};